module.exports = __webpack_public_path__ + "static/media/PDF_49.3dcc051e.pdf";